/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RecentSession
 */
export interface RecentSession {
    /**
     * 
     * @type {string}
     * @memberof RecentSession
     */
    sessionId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentSession
     */
    gameId?: string;
    /**
     * 
     * @type {string}
     * @memberof RecentSession
     */
    gameTitle?: string;
    /**
     * URL to game thumbnail image
     * @type {string}
     * @memberof RecentSession
     */
    gameThumbnail?: string;
    /**
     * Duration in minutes
     * @type {number}
     * @memberof RecentSession
     */
    duration?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentSession
     */
    xpEarned?: number;
    /**
     * 
     * @type {number}
     * @memberof RecentSession
     */
    questsCompleted?: number;
    /**
     * 
     * @type {Date}
     * @memberof RecentSession
     */
    timestamp?: Date;
}

/**
 * Check if a given object implements the RecentSession interface.
 */
export function instanceOfRecentSession(value: object): value is RecentSession {
    return true;
}

export function RecentSessionFromJSON(json: any): RecentSession {
    return RecentSessionFromJSONTyped(json, false);
}

export function RecentSessionFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecentSession {
    if (json == null) {
        return json;
    }
    return {
        
        'sessionId': json['sessionId'] == null ? undefined : json['sessionId'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
        'gameTitle': json['gameTitle'] == null ? undefined : json['gameTitle'],
        'gameThumbnail': json['gameThumbnail'] == null ? undefined : json['gameThumbnail'],
        'duration': json['duration'] == null ? undefined : json['duration'],
        'xpEarned': json['xpEarned'] == null ? undefined : json['xpEarned'],
        'questsCompleted': json['questsCompleted'] == null ? undefined : json['questsCompleted'],
        'timestamp': json['timestamp'] == null ? undefined : (new Date(json['timestamp'])),
    };
}

export function RecentSessionToJSON(json: any): RecentSession {
    return RecentSessionToJSONTyped(json, false);
}

export function RecentSessionToJSONTyped(value?: RecentSession | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'sessionId': value['sessionId'],
        'gameId': value['gameId'],
        'gameTitle': value['gameTitle'],
        'gameThumbnail': value['gameThumbnail'],
        'duration': value['duration'],
        'xpEarned': value['xpEarned'],
        'questsCompleted': value['questsCompleted'],
        'timestamp': value['timestamp'] == null ? undefined : ((value['timestamp']).toISOString()),
    };
}

